export const PERK_TREE = {
    nodes: [
        // ─── RAMA DIAGNÓSTICO ────────────────────────────────────────────────
        {
            id: 'triage_tactico',
            name: 'Triaje Táctico',
            branch: 'diagnostico',
            tier: 1,
            cost_sp: 1,
            desc: 'Ves las etiquetas del caso antes de aceptar la guardia.',
            requires: { level: 2, perks: [] },
            effects: [{ type: 'ui_show_case_tags_pre_accept', value: true }]
        },
        {
            id: 'ojo_aguila',
            name: 'Ojo de Águila',
            branch: 'diagnostico',
            tier: 2,
            cost_sp: 2,
            desc: '+15% XP en casos de Diagnóstico.',
            requires: { level: 4, perks: ['triage_tactico'] },
            effects: [{ type: 'xp_multiplier_tag', tag: 'diagnostico', value: 1.15 }]
        },
        {
            id: 'diagnostico_diferencial',
            name: 'Diagnóstico Diferencial',
            branch: 'diagnostico',
            tier: 2,
            cost_sp: 2,
            desc: 'La primera pista del caso no cuesta burnout.',
            requires: { level: 4, perks: ['triage_tactico'] },
            effects: [{ type: 'free_first_hint', value: true }]
        },
        {
            id: 'fotomemoria',
            name: 'Fotomemoria',
            branch: 'diagnostico',
            tier: 3,
            cost_sp: 3,
            desc: '+20% XP en casos de Alta dificultad. El Atlas muestra el error típico al repasar.',
            requires: { level: 7, perks: ['ojo_aguila'] },
            effects: [
                { type: 'xp_multiplier_difficulty', difficulty: 3, value: 1.20 },
                { type: 'ui_atlas_show_error_tipico', value: true }
            ]
        },

        // ─── RAMA MANEJO ─────────────────────────────────────────────────────
        {
            id: 'farmacopea_bolsillo',
            name: 'Farmacopea de Bolsillo',
            branch: 'manejo',
            tier: 1,
            cost_sp: 1,
            desc: '+50% de tiempo en preguntas de Farmacología.',
            requires: { level: 2, perks: [] },
            effects: [{ type: 'time_bonus_tag', tag: 'farmaco', value: 1.5 }]
        },
        {
            id: 'checklist_seguridad',
            name: 'Checklist de Seguridad',
            branch: 'manejo',
            tier: 2,
            cost_sp: 2,
            desc: 'La estabilidad inicial de cada guardia comienza en 115 en lugar de 100.',
            requires: { level: 5, perks: ['farmacopea_bolsillo'] },
            effects: [{ type: 'stability_bonus_start', value: 15 }]
        },
        {
            id: 'manejo_sepsis',
            name: 'Protocolo Séptico',
            branch: 'manejo',
            tier: 2,
            cost_sp: 2,
            desc: '+20% XP en casos de Infectología y Urgencias.',
            requires: { level: 5, perks: ['farmacopea_bolsillo'] },
            effects: [
                { type: 'xp_multiplier_tag', tag: 'urgencias', value: 1.20 },
                { type: 'xp_multiplier_tag', tag: 'infectologia', value: 1.20 }
            ]
        },
        {
            id: 'codigo_rojo',
            name: 'Código Rojo',
            branch: 'manejo',
            tier: 3,
            cost_sp: 3,
            desc: 'Los errores graves reducen la estabilidad un 20% menos. Los errores letales pierden solo 80% de estabilidad.',
            requires: { level: 8, perks: ['checklist_seguridad'] },
            effects: [{ type: 'stability_mitigation_global', value: 0.20 }]
        },

        // ─── RAMA GUARDIA ─────────────────────────────────────────────────────
        {
            id: 'cafe_urgencias',
            name: 'Café de Urgencias',
            branch: 'guardia',
            tier: 1,
            cost_sp: 1,
            desc: '+12% de probabilidad de recuperar 1 energía al terminar guardia perfecta.',
            requires: { level: 2, perks: [] },
            effects: [{ type: 'stamina_refund_chance', value: 0.12 }]
        },
        {
            id: 'segunda_opinion',
            name: 'Segunda Opinión',
            branch: 'guardia',
            tier: 2,
            cost_sp: 2,
            desc: 'El primer error de la guardia no aumenta el Burnout.',
            requires: { level: 5, perks: ['cafe_urgencias'] },
            effects: [{ type: 'first_error_no_burnout', value: true }]
        },
        {
            id: 'resistencia_guardia',
            name: 'Resistencia de Guardia',
            branch: 'guardia',
            tier: 2,
            cost_sp: 2,
            desc: '+10% XP en todas las guardias completadas.',
            requires: { level: 4, perks: ['cafe_urgencias'] },
            effects: [{ type: 'xp_multiplier_global', value: 1.10 }]
        },
        {
            id: 'residente_jefe',
            name: 'Residente Jefe',
            branch: 'guardia',
            tier: 3,
            cost_sp: 3,
            desc: 'Desbloquea 2ª ranura de mentor (restringida a rareza R o inferior).',
            requires: { level: 10, perks: ['segunda_opinion'] },
            effects: [{ type: 'extra_mentor_slot', value: 1, slot_restriction: 'R' }]
        },

        // ─── RAMA UNIVERSAL ───────────────────────────────────────────────────
        {
            id: 'resiliencia_cognitiva',
            name: 'Resiliencia Cognitiva',
            branch: 'universal',
            tier: 1,
            cost_sp: 1,
            desc: '+10% XP en todos los casos (se acumula con bonos de rama).',
            requires: { level: 3, perks: [] },
            effects: [{ type: 'xp_multiplier_global', value: 1.10 }]
        }
    ],
    branches: ['diagnostico', 'manejo', 'guardia', 'universal']
};

export class PerkSystem {
    static getModifiers(playerProfile) {
        const modifiers = {
            ui: {
                showCaseTagsPreAccept: false,
                atlasShowErrorTipico: false
            },
            time: { tagMultipliers: {} },
            scoring: {
                xpMultipliers: {},       // { tag: multiplier }
                xpGlobalMultiplier: 1,   // applied after tag multipliers
                xpDifficultyMultipliers: {} // { difficultyNum: multiplier }
            },
            guard: {
                staminaRefundChance: 0,
                stabilityBonusStart: 0,
                stabilityMitigationGlobal: 0,
                firstErrorNoBurnout: false,
                freeFirstHint: false
            }
        };

        if (!playerProfile || !playerProfile.activePerks) return modifiers;

        playerProfile.activePerks.forEach(perkId => {
            const node = PERK_TREE.nodes.find(n => n.id === perkId);
            if (!node) return;

            node.effects.forEach(effect => {
                switch (effect.type) {
                    case 'ui_show_case_tags_pre_accept':
                        modifiers.ui.showCaseTagsPreAccept = effect.value;
                        break;
                    case 'ui_atlas_show_error_tipico':
                        modifiers.ui.atlasShowErrorTipico = effect.value;
                        break;
                    case 'time_bonus_tag':
                        modifiers.time.tagMultipliers[effect.tag] =
                            (modifiers.time.tagMultipliers[effect.tag] || 1) * effect.value;
                        break;
                    case 'xp_multiplier_tag':
                        modifiers.scoring.xpMultipliers[effect.tag] =
                            (modifiers.scoring.xpMultipliers[effect.tag] || 1) * effect.value;
                        break;
                    case 'xp_multiplier_global':
                        modifiers.scoring.xpGlobalMultiplier *= effect.value;
                        break;
                    case 'xp_multiplier_difficulty':
                        modifiers.scoring.xpDifficultyMultipliers[effect.difficulty] =
                            (modifiers.scoring.xpDifficultyMultipliers[effect.difficulty] || 1) * effect.value;
                        break;
                    case 'stamina_refund_chance':
                        modifiers.guard.staminaRefundChance += effect.value;
                        break;
                    case 'stability_bonus_start':
                        modifiers.guard.stabilityBonusStart += effect.value;
                        break;
                    case 'stability_mitigation_global':
                        modifiers.guard.stabilityMitigationGlobal += effect.value;
                        break;
                    case 'first_error_no_burnout':
                        modifiers.guard.firstErrorNoBurnout = true;
                        break;
                    case 'free_first_hint':
                        modifiers.guard.freeFirstHint = true;
                        break;
                }
            });
        });

        return modifiers;
    }
}
